const publishDestinationEditorTabs = {
  SETTINGS: 'settings',
  PRIVACY:  'privacy',
  CODE:     'code',
};
publishDestinationEditorTabs.ALL = _.values(publishDestinationEditorTabs);

export default publishDestinationEditorTabs;
